import { createContext } from "react";
import type {
  DepositMethodId,
  DestinationMethodDescriptor,
  SelectableMethodDescriptor,
} from "./types";
import type { DepositReturnState } from "./hooks/useSkrillDepositReturn";
import type { Maybe } from "types/utilities";

export type DepositWizardContextState = {
  amount: number;
  setAmount: (amount: number) => void;

  // what the caller needs funded, in whole currency units, raised to the
  // minimum deposit. Only the betslip sets one, so it doubles as the signal
  // that the `Req` preset belongs in the amount presets
  requiredAmount?: number;

  // the redirect return this wizard was mounted for, if any
  depositReturn: DepositReturnState;

  // the methods the wizard was opened with
  selectableMethods: SelectableMethodDescriptor[];
  destinations: DestinationMethodDescriptor[];

  selectedMethod: SelectableMethodDescriptor;
  setSelectedMethodId: (methodId: DepositMethodId) => void;

  selectedCardId: Maybe<string>;
  setSelectedCardId: (cardId: Maybe<string>) => void;

  // a payment is in flight, so the wizard's inputs and every exit route are
  // held shut until an outcome screen is reached
  submitting: boolean;
  setSubmitting: (submitting: boolean) => void;

  // closes the modal hosting the wizard
  close: () => void;

  // the caller holds state that an off-site redirect would destroy, so the
  // redirecting methods warn before sending the user away
  warnBetslipLoss: boolean;

  closeOnSuccess: boolean;
};

export const DepositWizardContext =
  createContext<DepositWizardContextState | null>(null);
